import { getAuthorization } from 'controllers/controller';
import { getSkillsStatsService } from 'services/dashboard/getSkillsStats';

export const getSkillsStats = async (jobId, last, talentStatus) => {
  const authorization = getAuthorization();

  const { data } = await getSkillsStatsService(
    authorization,
    {
      jobId,
      last,
      talentStatus,
    },
    16
  );

  return data.response.skillName;
};

export const formatSkillsStats = (response) => {
  const data = response.map(({ field, count }) => ({
    y: count,
    name: field,
  }));
  return { data };
};
